import api from "../api";

const pettyCashService = {
  // Get petty cash data (main listing)
  getPettyCash: async () => {
    try {
      const response = await api.get("/petty-cash/data");
      return response.data;
    } catch (error) {
      console.error("Error fetching petty cash data:", error);
      throw error;
    }
  },

  // Get petty cash summary
  getPettyCashSummary: async (startDate, endDate) => {
    try {
      const response = await api.get("/petty-cash/summary", {
        params: { start_date: startDate, end_date: endDate },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching petty cash summary:", error);
      throw error;
    }
  },

  // Get all petty cash expenses
  getExpenses: async () => {
    try {
      const response = await api.get("/petty-cash");
      return response.data;
    } catch (error) {
      console.error("Error fetching petty cash expenses:", error);
      throw error;
    }
  },

  // Get petty cash expense by ID
  getExpense: async (id) => {
    try {
      const response = await api.get(`/petty-cash/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching petty cash expense:", error);
      throw error;
    }
  },

  // Create petty cash expenses
  createExpenses: async (formData) => {
    try {
      const response = await api.post("/petty-cash", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating petty cash expenses:", error);
      throw error;
    }
  },

  // Update petty cash expense
  updateExpense: async (id, formData) => {
    try {
      const response = await api.put(`/petty-cash/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating petty cash expense:", error);
      throw error;
    }
  },

  // Delete petty cash expense
  deleteExpense: async (id) => {
    try {
      const response = await api.delete(`/petty-cash/${id}/destroy`);
      return response.data;
    } catch (error) {
      console.error("Error deleting petty cash expense:", error);
      throw error;
    }
  },

  // Delete petty cash expense (alias for compatibility)
  deletePettyCash: async (id) => {
    try {
      const response = await api.delete(`/petty-cash/${id}/destroy`);
      return response.data;
    } catch (error) {
      console.error("Error deleting petty cash expense:", error);
      throw error;
    }
  },

  // Get employees for typeahead
  getEmployees: async () => {
    try {
      const response = await api.get("/petty-cash/employees");
      return response.data;
    } catch (error) {
      console.error("Error fetching employees:", error);
      throw error;
    }
  },

  // Get file (returns presigned URL for direct download)
  getFile: async (id, field) => {
    try {
      // Backend returns presigned URL, download directly from S3
      const response = await api.get(`/petty-cash/${id}/${field}`);
      
      if (response.data.success && response.data.presignedUrl) {
        // Download directly from presigned URL
        const link = document.createElement('a');
        link.href = response.data.presignedUrl;
        link.download = response.data.filename || `petty-cash-${id}-${field}.pdf`;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return { success: true };
      } else {
        throw new Error(response.data.message || 'Failed to get download URL');
      }
    } catch (error) {
      console.error("Error fetching file:", error);
      throw error;
    }
  },

  // Download file (alias for getFile - for compatibility)
  downloadFile: async (id, field) => {
    return await pettyCashService.getFile(id, field);
  },

  // Remove file
  removeFile: async (id, field) => {
    try {
      const response = await api.get(`/petty-cash/${id}/remove/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error removing file:", error);
      throw error;
    }
  },

  // Export CSV
  exportCSV: async (params = {}) => {
    try {
      const response = await api.get("/petty-cash/export/csv", {
        params,
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error exporting CSV:", error);
      throw error;
    }
  },

  // Export PDF
  exportPDF: async (params = {}) => {
    try {
      const response = await api.get("/petty-cash/export/pdf", {
        params,
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error exporting PDF:", error);
      throw error;
    }
  },
};

export default pettyCashService;
